module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/data-bg-2.57b21222.png";